import { withStyles } from '@material-ui/core';
const styles = (theme) => ({
  container: {
    display: 'flex',
    gap: '24px'
  },
  infoContainer: {
    flexDirection: 'row',
    display: 'flex',
    padding: '8px 0'
  },
  infoPadding: {
    padding: '0 12px'
  },
  infoTitle: {
    fontSize: theme.textFontSize,
    fontWeight: 400,
    lineHeight: '16px',
    color: theme.dispatchPanelHeaderColor,
    flexShrink: 0
  },
  infoValue: {
    fontSize: theme.textFontSize,
    fontWeight: 600,
    lineHeight: '16px',
    color: theme.TextColor
  }
});

const PickupToggleInfo = ({ classes, pickupInfoList }) => {
  return (
    <div className={classes.container}>
      {pickupInfoList.map((item, index) => (
        <div className={classes.infoContainer} key={index}>
          <div className={classes.infoTitle}>{item.label}</div>
          <div className={`${classes.infoValue} ${classes.infoPadding}`}>{item.value}</div>
        </div>
      ))}
    </div>
  );
};

export default withStyles(styles)(PickupToggleInfo);
